

import React from "react";

export const PaySftLogo: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-[60px] h-[60px]",
    ...props
}) => {
    return (

        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 180 180"
            className={className}
            {...props}
        >
            <defs>
                <clipPath id="paysft-clippath">
                    <path fill="none" d="M82.9,6.7s-36.1,20.3-49.6,27.5c-7.2,3.8-7.1,6.8-7.1,11.9h0v54.7h0v34.3c0,1.5-.9,5,3.5,7.6,0,0,34.8,21.7,46.8,29.3,2,1.3,2.7,2,3.7,2.4,9.1,3.5,9.7-5,9.8-8.2,0-.9,0-15.9,0-16.8.1-4.9,2.7-9.6,7.1-11.9,12.2-6.4,36.7-19.5,49.5-24.6,7.1-2.9,7.1-6.9,7.1-11.8h0v-54.8h0c0-4.9.1-8-7.1-11.9L97,6.7c-2.2-1.2-4.6-1.8-7-1.8s-4.9.6-7,1.8" />
                </clipPath>
 
                <linearGradient id="paysft-lg" x1="-593.8" y1="475.3" x2="-592.1" y2="475.3" gradientTransform="translate(50729 40684.7) scale(85.4 -85.4)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#8a00ff" />
                    <stop offset=".1" stopColor="#8a00ff" />
                    <stop offset=".6" stopColor="#005cea" />
                    <stop offset="1" stopColor="#00b4ea" />
                </linearGradient>
 
                <clipPath id="paysft-clippath-1">
                    <path fill="none" d="M153.7,100.9h0M80.8,172.6c-.4-.1-.7-.4-1.4-.8-.5-.4-1.2-.8-2.1-1.4-11.9-7.5-46.4-29-46.8-29.3-2.8-1.7-2.7-3.7-2.6-5.3,0-.3,0-.5,0-.8V45.9c0-4.7,0-6.9,6.2-10.1,13.3-7.1,49.3-27.3,49.6-27.5,1.9-1,4-1.6,6.2-1.6s4.3.5,6.2,1.6l49.6,27.5c6.2,3.4,6.2,5.5,6.2,10.1v55h0c0,.1,0,.3,0,.3,0,4.8,0,7.7-6,10.1-11,4.4-30.5,14.7-43.4,21.4-2.3,1.2-4.4,2.3-6.2,3.2-4.9,2.5-8,7.7-8.1,13.4,0,.5,0,3.4,0,8.1,0,3.8,0,8.2,0,8.7-.2,6.5-2.4,7.3-4.1,7.3s-2-.2-3.2-.7M82.9,6.7s-36.1,20.3-49.6,27.5c-7.2,3.8-7.1,6.8-7.1,11.9h0v54.7h0v34.3c0,1.5-.9,5,3.5,7.6,0,0,34.8,21.7,46.8,29.3,2,1.3,2.7,2,3.7,2.4,1.5.6,2.8.8,3.9.8,5.4,0,5.8-6.4,5.9-9,0-.9,0-15.9,0-16.8.1-4.9,2.7-9.6,7.1-11.9,12.2-6.4,36.7-19.5,49.5-24.6,7.1-2.9,7.1-6.9,7.1-11.8,0,0,0,0,0,0h0v-54.8h0c0-4.9.1-8-7.1-11.9L97,6.7c-2.2-1.2-4.6-1.8-7-1.8s-4.9.6-7,1.8" />
                </clipPath>
 
                <linearGradient id="paysft-lg1" x1="-593.9" y1="475" x2="-592.2" y2="475" gradientTransform="translate(55543.9 44507.4) scale(93.5 -93.5)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#0d0d0d" />
                    <stop offset=".2" stopColor="#999" />
                    <stop offset=".8" stopColor="#999" />
                    <stop offset="1" stopColor="#0d0d0d" />
                </linearGradient>
 
                <mask id="paysft-mask" x="-48.3" y="-50.8" width="275.9" height="281.5" maskUnits="userSpaceOnUse">
                    <rect fill="url(#paysft-lg1)" x="-8.6" y="-15.8" width="196.4" height="211.7" transform="translate(-33 56.9) rotate(-30)" />
                </mask>
 
                <linearGradient id="paysft-lg2" x1="-593.9" y1="475" x2="-592.2" y2="475" gradientTransform="translate(55543.9 44507.4) scale(93.5 -93.5)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#fff" />
                    <stop offset=".2" stopColor="#fff" />
                    <stop offset=".8" stopColor="#fff" />
                    <stop offset="1" stopColor="#fff" />
                </linearGradient>
 
                <clipPath id="paysft-clippath-2">
                    <path fill="none" d="M26.2,100.5v34.7c-.1,2.6-.1,5.4,3.6,7.4,2.3,1.2,6.3,4,6.3,4l19.7,12.3,23.7,15s10.1,5.6,10.3-7.9v-16.7s-.4-7.8,6.9-12l17.4-9.1,19.8-10,11.8-5.4s7.1-1.9,7.4-8.4l-62.7-32.3-64.6,28.4Z" />
                </clipPath>
 
                <linearGradient id="paysft-lg3" x1="-590.5" y1="471.3" x2="-588.8" y2="471.3" gradientTransform="translate(-30342.9 -24199) rotate(-180) scale(51.6 -51.6)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#000" />
                    <stop offset=".1" stopColor="#000" />
                    <stop offset=".7" stopColor="gray" />
                    <stop offset="1" stopColor="#000" />
                </linearGradient>
 
                <mask id="paysft-mask-1" x="-22" y="15.1" width="223.7" height="221.6" maskUnits="userSpaceOnUse">
                    <rect fill="url(#paysft-lg3)" x="10.6" y="43.4" width="158.4" height="164.9" transform="translate(-64.5 135.7) rotate(-58.1)" />
                </mask>
 
                <linearGradient id="paysft-lg4" x1="-590.5" y1="471.3" x2="-588.8" y2="471.3" gradientTransform="translate(-30342.9 -24199) rotate(-180) scale(51.6 -51.6)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#fff" />
                    <stop offset=".1" stopColor="#fff" />
                    <stop offset=".7" stopColor="#fff" />
                    <stop offset="1" stopColor="#fff" />
                </linearGradient>
 
                <clipPath id="paysft-clippath-3">
                    <path fill="none" d="M80.5,8.1c0,.5-42.7,23.6-48.9,27.1-6.6,3.6-5.4,9.5-5.4,9.5v2.8s0,53.1,0,53.1l64.6-28.4V4.9c-.1,0-.2,0-.3,0-4.7,0-10,3.2-10,3.2" />
                </clipPath>
 
                <linearGradient id="paysft-lg5" x1="-593.8" y1="471.3" x2="-592.1" y2="471.3" gradientTransform="translate(-28539 36047.5) rotate(90) scale(60.7 -60.7)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#000" />
                    <stop offset=".1" stopColor="#000" />
                    <stop offset=".7" stopColor="gray" />
                    <stop offset="1" stopColor="#000" />
                </linearGradient>
 
                <mask id="paysft-mask-2" x="-8.5" y="-18.2" width="132.8" height="141.8" maskUnits="userSpaceOnUse">
                    <rect fill="url(#paysft-lg5)" x="9.4" y="-4" width="97.1" height="113.4" transform="translate(-15.6 25.9) rotate(-22.3)" />
                </mask>
 
                <linearGradient id="paysft-lg6" x1="-593.8" y1="471.3" x2="-592.1" y2="471.3" gradientTransform="translate(-28539 36047.6) rotate(90) scale(60.7 -60.7)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#fff" />
                    <stop offset=".1" stopColor="#fff" />
                    <stop offset=".7" stopColor="#fff" />
                    <stop offset="1" stopColor="#fff" />
                </linearGradient>
 
                <clipPath id="paysft-clippath-4">
                    <path fill="none" d="M90.8,4.9v67.3l62.7,32.3s.3-.9.3-7.4c-.1-11.2,0-50.4,0-50.4,0,0,1.5-7.7-6-12-6.4-3.7-47.9-26.5-47.9-26.5,0,0-4.5-3.4-8.7-3.4-.1,0-.2,0-.4,0" />
                </clipPath>
 
                <linearGradient id="paysft-lg7" x1="-591.6" y1="476.4" x2="-589.9" y2="476.4" gradientTransform="translate(-37987 30766.3) rotate(180) scale(64.5)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#000" />
                    <stop offset=".1" stopColor="#000" />
                    <stop offset=".7" stopColor="gray" />
                    <stop offset="1" stopColor="#000" />
                </linearGradient>
 
                <mask id="paysft-mask-3" x="56.3" y="-17.4" width="133.3" height="144.2" maskUnits="userSpaceOnUse">
                    <rect fill="url(#paysft-lg7)" x="64.8" y="6.2" width="116.5" height="96.9" transform="translate(26.4 148.4) rotate(-68.1)" />
                </mask>
 
                <linearGradient id="paysft-lg8" x1="-591.6" y1="476.4" x2="-589.9" y2="476.4" gradientTransform="translate(-37987 30766.3) rotate(180) scale(64.5)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#fff" />
                    <stop offset=".1" stopColor="#fff" />
                    <stop offset=".7" stopColor="#fff" />
                    <stop offset="1" stopColor="#fff" />
                </linearGradient>
 
                <linearGradient id="paysft-lg9" x1="-597.3" y1="474.7" x2="-595.6" y2="474.7" gradientTransform="translate(22287.3 17762.5) scale(37.3 -37.3)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#000" />
                    <stop offset=".5" stopColor="#4d4d4d" />
                    <stop offset="1" stopColor="#000" />
                </linearGradient>
 
                <mask id="paysft-mask-4" x="-1365.3" y="-582.7" width="2325.7" height="1307.6" maskUnits="userSpaceOnUse">
                    <rect fill="url(#paysft-lg9)" x="-1365.3" y="-582.7" width="2325.7" height="1307.6" />
                </mask>
 
                <linearGradient id="paysft-lg10" x1="-597.3" y1="474.3" x2="-595.6" y2="474.3" gradientTransform="translate(22287.3 17762.5) scale(37.3 -37.3)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#fff" />
                    <stop offset=".5" stopColor="#fff" />
                    <stop offset="1" stopColor="#fff" />
                </linearGradient>
 
                <linearGradient id="paysft-lg11" x1="-596.7" y1="474.8" x2="-595" y2="474.8" gradientTransform="translate(22103.5 17587.2) scale(36.9 -36.9)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#000" />
                    <stop offset=".5" stopColor="#4d4d4d" />
                    <stop offset="1" stopColor="#000" />
                </linearGradient>
 
                <mask id="paysft-mask-5" x="-1365.3" y="-582.7" width="2325.7" height="1307.6" maskUnits="userSpaceOnUse">
                    <rect fill="url(#paysft-lg11)" x="-1365.3" y="-582.7" width="2325.7" height="1307.6" />
                </mask>
 
                <linearGradient id="paysft-lg12" x1="-596.7" y1="474.3" x2="-595" y2="474.3" gradientTransform="translate(22103.5 17587.2) scale(36.9 -36.9)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#fff" />
                    <stop offset=".5" stopColor="#fff" />
                    <stop offset="1" stopColor="#fff" />
                </linearGradient>
 
                <linearGradient id="paysft-lg13" x1="-591.5" y1="486.1" x2="-589.8" y2="486.1" gradientTransform="translate(18483 -22664.8) rotate(-90) scale(38.4 -38.4)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#000" />
                    <stop offset=".5" stopColor="#4d4d4d" />
                    <stop offset="1" stopColor="#000" />
                </linearGradient>
 
                <mask id="paysft-mask-6" x="-1365.3" y="-582.7" width="2325.7" height="1307.6" maskUnits="userSpaceOnUse">
                    <rect fill="url(#paysft-lg13)" x="-1365.3" y="-582.7" width="2325.7" height="1307.6" />
                </mask>
 
                <linearGradient id="paysft-lg14" x1="-591.5" y1="478.5" x2="-589.8" y2="478.5" gradientTransform="translate(18483 -22664.8) rotate(-90) scale(38.4 -38.4)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#fff" />
                    <stop offset=".5" stopColor="#fff" />
                    <stop offset="1" stopColor="#fff" />
                </linearGradient>
 
                <clipPath id="paysft-clippath-5">
                    <rect fill="none" x="47.5" y="57.8" width="86.4" height="56.5" />
                </clipPath>
                <clipPath id="paysft-clippath-6">
                    <rect fill="none" x="47.5" y="38.8" width="86.3" height="56.5" />
                </clipPath>
                <clipPath id="paysft-clippath-7">
                    <rect fill="none" x="47.5" y="19.1" width="86.3" height="56.5" />
                </clipPath>
            </defs>
 
            <g clipPath="url(#paysft-clippath)">
                <rect fill="url(#paysft-lg)" x="-15.2" y="-16.2" width="209.6" height="215" transform="translate(-37.7 79) rotate(-40)" />
            </g>
            <g clipPath="url(#paysft-clippath-1)">
                <g mask="url(#paysft-mask)">
                    <rect fill="url(#paysft-lg2)" x="-8.6" y="-15.8" width="196.4" height="211.7" transform="translate(-33 56.9) rotate(-30)" />
                </g>
            </g>
            <g clipPath="url(#paysft-clippath-2)">
                <g mask="url(#paysft-mask-1)">
                    <rect fill="url(#paysft-lg4)" x="10.6" y="43.4" width="158.4" height="164.9" transform="translate(-64.5 135.7) rotate(-58.1)" />
                </g>
            </g>
            <g clipPath="url(#paysft-clippath-3)">
                <g mask="url(#paysft-mask-2)">
                    <rect fill="url(#paysft-lg6)" x="9.4" y="-4" width="97.1" height="113.4" transform="translate(-15.6 25.9) rotate(-22.3)" />
                </g>
            </g>
            <g clipPath="url(#paysft-clippath-4)">
                <g mask="url(#paysft-mask-3)">
                    <rect fill="url(#paysft-lg8)" x="64.8" y="6.2" width="116.5" height="96.9" transform="translate(26.4 148.4) rotate(-68.1)" />
                </g>
            </g>
            <g mask="url(#paysft-mask-4)">
                <polyline fill="url(#paysft-lg10)" points="90.7 71.9 28 99.8 28 99.8 90.7 71.9" />
            </g>
            <g mask="url(#paysft-mask-5)">
                <polyline fill="url(#paysft-lg12)" points="90.8 71.9 151.8 103.7 151.8 103.7 151.8 103.7 90.8 71.9 90.8 71.9 90.8 71.9" />
            </g>
            <g mask="url(#paysft-mask-6)">
                <polyline fill="url(#paysft-lg14)" points="90.8 6.7 90.8 72.2 90.8 72.2 90.8 6.7" />
            </g>
            <path fill="#fff" d="M130.5,96.8l-36.5,21.6c-2.1,1.2-4.8,1.2-6.9,0l-36.4-21.6s-4.8-7-3-12.4c-.7,2.7.3,5.8,3,7.5l36.5,21.5c2.1,1.3,4.8,1.3,6.9,0l36.5-21.5c3.7-2.2,4.3-6.9,1.8-9.9,1.9,1.7,3.7,9.7-1.9,14.9" />
            <g opacity=".6">
                <g clipPath="url(#paysft-clippath-5)">
                    <path fill="#fff" d="M132.4,81.9h0c-.4-.6-1.1-1.2-1.8-1.6l-36.5-21.5c-2.1-1.3-4.8-1.3-6.9,0,0,0-27.5,15.9-36.5,21.5-.2.1-.4.3-.6.6-.9.8-1.6,1.6-2.1,2.6-.1.3-.3.6-.4,1-.7,2.7.3,5.8,3,7.5l36.5,21.5c2.1,1.3,4.8,1.3,6.9,0l36.5-21.5c3.7-2.2,4.3-6.9,1.8-9.9" />
                </g>
            </g>
            <path fill="#fff" d="M130.5,77.8l-36.5,21.6c-2.1,1.2-4.8,1.2-6.9,0l-36.4-21.6s-4.8-7-3-12.4c-.7,2.7.3,5.8,3,7.5l36.5,21.5c2.1,1.3,4.8,1.3,6.9,0l36.5-21.5c3.6-2.2,4.3-6.9,1.8-9.9,1.9,1.7,3.7,9.7-1.9,14.9" />
            <g opacity=".8">
                <g clipPath="url(#paysft-clippath-6)">
                    <path fill="#fff" d="M132.4,62.9h0c-.4-.7-1.1-1.2-1.8-1.6l-36.5-21.5c-2.1-1.3-4.8-1.3-6.9,0l-36.5,21.5c-.2.1-.4.2-.6.5h-.1c-.5.4-1,.9-1.2,1.3-.4.4-.6.8-.8,1.2-.1.4-.3.7-.4,1.1-.7,2.7.3,5.8,3,7.5l36.5,21.5c2.1,1.3,4.8,1.3,6.9,0l36.5-21.5c3.6-2.2,4.3-6.9,1.8-9.9" />
                </g>
            </g>
            <path fill="#fff" d="M130.5,58.1l-36.5,21.6c-2.1,1.2-4.8,1.2-6.9,0l-36.4-21.6s-4.8-7-3-12.4c-.7,2.7.3,5.8,3,7.5l36.5,21.5c2.1,1.3,4.8,1.3,6.9,0l36.5-21.5c3.6-2.2,4.3-6.9,1.8-9.9,1.9,1.7,3.7,9.7-1.9,14.9" />
            <g opacity=".9">
                <g clipPath="url(#paysft-clippath-7)">
                    <path fill="#fff" d="M132.4,43.2h0c-.4-.7-1.1-1.2-1.8-1.6l-36.5-21.5c-2.1-1.3-4.8-1.3-6.9,0l-36.5,21.5c-.2.1-.4.2-.6.5h-.1c-.5.4-1,.9-1.2,1.3-.4.4-.6.8-.8,1.2-.1.4-.3.7-.4,1.1-.7,2.7.3,5.8,3,7.5l36.5,21.5c2.1,1.3,4.8,1.3,6.9,0l36.5-21.5c3.6-2.2,4.3-6.9,1.8-9.9" />
                </g>
            </g>
        </svg>
    );
};

